var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/core-js/modules/_cof.js
// module id = 55
// module chunks = 2 3 4 5 6 7 8 9 10 11 12